/**
 * Build a query string from an object of data
 *
 * @param  {Record<string, string | number>} object Object to transform into a query string
 * @return {String} Query string
 */
export default function objectToQueryString(object) {
  return new URLSearchParams(Object.entries(object).reduce((a, [k, v]) => (v ? ((a[k] = v), a) : a), {})).toString();
}
